module.exports = __webpack_public_path__ + "img/americano.bc466039.png";